module.exports = __webpack_public_path__ + "static/media/placeholder.9cedaebf.png";